import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { PaymentB2Crequest } from 'src/app/core/models/payment-b2c-request.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent {
  paymentB2Crequest!: PaymentB2Crequest;
  paymentForm!: FormGroup;
  quotationId: string = '';
  quotesId: string = '';
  jengapgwUrl:string=environment.jengapgwUrl;
  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    private restService: RestService) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
      this.quotesId = params['quotesId'];
    });
  }

  ngOnInit(): void {
    this.PaymentFormLoadDataOnPageLage();
  }

  PaymentFormLoadDataOnPageLage() {
    let loginTokenRequestParams = {
      QuotationID: this.quotationId
    }
    let userInfoParams = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    const loginTokenRequestApiCall$ = this.restService.postData(loginTokenRequestParams, 'api/Response/LoginTokenRequest');
    const userInfoApiCall$ = this.restService.postData(userInfoParams, 'api/Quotation/UserInfo');
    this.loader.show();
    combineLatest([loginTokenRequestApiCall$, userInfoApiCall$]).subscribe({

      next: ([loginTokenRequestData, userInfoData]) => {
        try {
          if (loginTokenRequestData.rcode == 200 && userInfoData.rcode == 200) {
            this.paymentB2Crequest = loginTokenRequestData.rObj.PaymentB2Crequest;
            this.paymentB2Crequest.AccessToken = loginTokenRequestData.rObj.PaymentLoginResponse.accessToken;
            this.paymentB2Crequest.CallbackUrl = `${environment.siteBaseUrl}policy/payment-info/${this.quotationId}`;

            let policyHolderData = userInfoData.rObj.Traveller.find((traveller: any) => traveller.IsPolicyHolder);
            if (policyHolderData) {
              this.paymentB2Crequest.CustomerFirstName = policyHolderData.FirstName;
              this.paymentB2Crequest.CustomerLastName = policyHolderData.LastName;
              this.paymentB2Crequest.CustomerEmail = policyHolderData.EmailId;
              this.paymentB2Crequest.CustomerPhone = `${this.paymentB2Crequest.PhoneCode} ${policyHolderData.sPhoneNumber}`;
              this.paymentB2Crequest.CustomerPostalCodeZip = userInfoData.rObj.Quotations.AddressLine3;
              this.paymentB2Crequest.CustomerAddress = userInfoData.rObj.Quotations.AddressLine2;

            }

          }else if(loginTokenRequestData.rcode != 200){
            this.errorHandler.handleRcodeError(loginTokenRequestData);
          }else if(userInfoData.rcode != 200){
            this.errorHandler.handleRcodeError(userInfoData);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      error: error => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      }
    });
  }
}
